import axios from 'axios';
// import { getData } from "../contexts/authContext";

// const API_URL = "https://ctj1mt0rr2.execute-api.us-east-1.amazonaws.com/dev";
const API_URL =
  process.env.REACT_APP_COGNITO_API_URL ||
  'https://ctj1mt0rr2.execute-api.us-east-1.amazonaws.com/dev';

// Importin this caused webpack error
const getData = async (key: string) => {
  try {
    const value = localStorage.getItem(key);
    if (value !== null) {
      return value;
    }
  } catch (e) {
    throw e;
    // error reading value
  }
};

const instance = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
    Authorization: '',
  },
});

// const instance = axios.create({
//   baseURL: API_URL,

// });

instance.interceptors.request.use(async (config: any) => {
  const token = await getData('idToken');
  // if (token) {
  config.headers.Authorization = token;
  // }
  return config;
});

export const changeEmail = async (newEmail: string, email: string) => {
  const tokenAccess = await getData('accessToken');
  const token = await getData('idToken');
  return instance.post(
    '/change-email?email=' + email,
    { newEmail: newEmail, accessToken: tokenAccess },
    {
      headers: {
        Authorization: 'Bearer ' + token,
      },
    }
  );
};

export const confirmChangeEmail = async (
  code: string,
  newEmail: string,
  email: string
) => {
  const tokenAccess = await getData('accessToken');
  const token = await getData('idToken');
  const data = JSON.stringify({
    accessToken: tokenAccess,
    code: code,
    newEmail: email,
  });
  return instance.post('/change-email-confirm?email=' + newEmail, data, {
    headers: {
      Authorization: 'Bearer ' + token,
    },
  });
};

export const changePhone = async (phone: string, email: string) => {
  const tokenAccess = await getData('accessToken');
  const token = await getData('idToken');
  const data = JSON.stringify({
    phone_number: phone,
    accessToken: tokenAccess,
  });
  return instance.post(
    '/change-email?email=' + email,
    { phone_number: phone, accessToken: tokenAccess },
    {
      headers: {
        Authorization: 'Bearer ' + token,
      },
    }
  );
};

export const confirmChangePhone = async (
  code: string,
  phone: string,
  email: string
) => {
  const tokenAccess = await getData('accessToken');
  const token = await getData('idToken');
  const data = JSON.stringify({
    accessToken: tokenAccess,
    code: code,
    phone_number: phone,
  });
  return instance.post('/change-email-confirm?email=' + email, data, {
    headers: {
      Authorization: 'Bearer ' + token,
    },
  });
};

export const adminDisableUser = async (email: string) => {
  const tokenAccess = await getData('accessToken');
  const token = await getData('idToken');
  return instance.post(
    '/disable-user',
    { email: email },
    {
      headers: {
        Authorization: 'Bearer ' + token,
      },
    }
  );
};

export const adminEnableUser = async (email: string) => {
  const tokenAccess = await getData('accessToken');
  const token = await getData('idToken');
  return instance.post(
    '/enable-user',
    { email: email },
    {
      headers: {
        Authorization: 'Bearer ' + token,
      },
    }
  );
};

export const getMFAPreference = async () => {
  const token = await getData('idToken');
  return instance.get('/mfa-preference', {
    headers: {
      Authorization: 'Bearer ' + token,
    },
  });
};

export const setMFAPreference = async (mfaPreference: boolean) => {
  const token = await getData('idToken');
  return instance.post(
    '/mfa-preference',
    { mfa_active: mfaPreference },
    {
      headers: {
        Authorization: 'Bearer ' + token,
      },
    }
  );
};
